"use client";

import { ArrowRight, Clock, Shield, ShieldCheck, Umbrella as UmbrellaIcon, UserCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CertificacionesYPermisos() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const banner = useRevealOnScroll<HTMLDivElement>();
  const cta = useRevealOnScroll<HTMLDivElement>();
  const badges = [{
    icon: Shield,
    title: "Seguridad Certificada",
    description: "Contamos con todos los permisos federales y estatales vigentes para operar con total legalidad.",
    label: "Registro Federal"
  }, {
    icon: UserCheck,
    title: "Personal Veteado",
    description: "Nuestros elementos pasan por rigurosos controles de confianza y evaluaciones psicométricas constantes.",
    label: "Confianza Total"
  }, {
    icon: Clock,
    title: "Respuesta Inmediata",
    description: "Monitoreo 24/7 con protocolos de reacción rápida ante cualquier eventualidad o señal de alerta.",
    label: "SLA 99.9%"
  }, {
    icon: UmbrellaIcon,
    title: "Protección Integral",
    description: "Cobertura total en servicios intramuros, custodia de mercancías y seguridad electrónica avanzada.",
    label: "Grupo Poseidón"
  }];
  const certifications = [{
    label: "Permiso Federal SSP"
  }, {
    label: "Certificación ISO 9001"
  }, {
    label: "Registro REPSE"
  }];
  return <section data-section-id="673" id="certificaciones-y-permisos" className="relative overflow-hidden bg-background py-32 px-4 sm:px-6 lg:px-8">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-[80%] opacity-40" style={{
      background: "radial-gradient(ellipse 60% 70% at 50% 100%, hsla(45, 100%, 52%, 0.15), transparent 70%)"
    }} />

      <div className="relative mx-auto max-w-7xl">
        {}
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-sm font-medium tracking-[0.15em] text-primary uppercase font-mono">
            Compromiso y Legalidad
          </p>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[56px] lg:leading-[1.05] font-bold text-foreground font-default tracking-tight">
            Disciplina que garantiza su tranquilidad.
          </h2>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            En Grupo Poseidón, la seguridad no es una opción, es un estándar. Operamos bajo los más estrictos marcos legales y tecnológicos del país.
          </p>
        </div>

        {}
        <div ref={grid.ref} className={`mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {badges.map((badge, i) => {
          const Icon = badge.icon;
          return <Card data-index={i} key={i} className="bg-card border border-border rounded-md p-8 min-h-[280px] flex flex-col items-center text-center shadow-md hover:border-primary/40 transition-colors duration-300">
                <div className="relative mb-6">
                  <div className="absolute inset-0 rounded-md blur-xl opacity-20" style={{
                background: "var(--primary)"
              }} aria-hidden="true" />
                  <div className="relative flex items-center justify-center w-[72px] h-[72px] rounded-md border-2 border-border bg-background">
                    <Icon className="w-9 h-9 text-primary" strokeWidth={1.5} />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-foreground font-default mb-3">
                  {badge.title}
                </h3>
                <p className="text-sm text-muted-foreground font-default leading-relaxed mb-6 flex-1">
                  {badge.description}
                </p>
                <Badge variant="outline" className="bg-primary/10 border-primary/30 text-primary font-medium tracking-wide uppercase text-[10px] px-3 py-1 rounded-md">
                  {badge.label}
                </Badge>
              </Card>;
        })}
        </div>

        {}
        <div ref={banner.ref} className={`mt-16 rounded-md border border-border bg-card p-8 lg:p-12 transition-all duration-700 ease-out ${banner.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 lg:gap-6">
              {certifications.map((cert, i) => <div data-index={i} key={i} className="flex items-center gap-2 px-4 py-3 rounded-md border border-border bg-background">
                  <ShieldCheck className="w-5 h-5 text-primary" strokeWidth={1.5} />
                  <span className="text-sm font-medium text-foreground font-default tracking-wide">
                    {cert.label}
                  </span>
                </div>)}
            </div>

            {}
            <div className="text-center lg:text-right">
              <p className="text-2xl lg:text-3xl font-semibold text-foreground font-default leading-tight">
                Más de 15 años protegiendo activos.{" "}
                <span className="text-primary">Cero incidentes críticos.</span>
              </p>
            </div>
          </div>
        </div>

        {}
        <div ref={cta.ref} className={`mt-12 text-center transition-all duration-700 ease-out ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild variant="ghost" size="lg" className="text-primary hover:text-primary/80 hover:bg-primary/10 font-semibold text-base rounded-md">
            <Link to="/AboutUsPage">
              Ver nuestra política de calidad y cumplimiento
              <ArrowRight className="ml-1 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}